module.exports = __webpack_public_path__ + "img/ka.a3259ac2.png";